import ko from 'knockout';
import resourceHelper from '../../inv-resource-helper/resourceHelper';

/**
 * Binding to display localised text based on the data in the server-side resource files
 * @example
 * <h2 data-bind="restext: 'Registration'"></h2>
 * <h2 data-bind="restext: { key: 'Registration', params: { name: 'Mike' } }"></h2>
 */
ko.bindingHandlers.restext = {
  update: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {

    var text = getLocalizedString(ko.utils.unwrapObservable(valueAccessor()));

    ko.bindingHandlers.text.update(
      element,
      function () {
        return text;
      },
      allBindingsAccessor,
      viewModel,
      context);
  }
};

function getLocalizedString(binding) {

  var value;

  if (binding === null) {
    return null;
  }

  // Allow both restext: 'Home' as string and restext: { key: 'Home' } as an object
  if (typeof binding === 'string' || binding instanceof String) {
    binding = { key: binding };
  }

  value = resourceHelper.getString(binding.key);
  value = resourceHelper.replacePlaceholders(value, binding.params);

  return value;
}
